
































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue'
import PxNumberInput from "@/views/components/input/formFields/PxNumberInput.vue";
import QuickHelp from "@/views/components/input/QuickHelp.vue";
import {UnitSystem} from "@/interfaces/units";
import {designStore} from "@/store/store";
import {Route} from "vue-router";
import {createPorousValidations} from "@/modules/design/lib/validations/porous";
import ValidatedInputPageWrapper from "@/views/components/input/ValidatedInputPageWrapper.vue";


@Component({
  components: {
    ValidatedInputPageWrapper,
    QuickHelp,
    PxNumberInput,
    InputPageWrapper
  },
})
export default class PorousLayers extends Vue {
  @Prop() readonly pxDesignId!: string;
  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentPorous;
  }

  get scenarioImperial(){
    return designStore.currentPorousImperial
  }

  validations(){
    return createPorousValidations(this.scenarioImperial)
  }

  save(){
    this.sync();
    designStore.saveCurrentPorousScenario()
  }

  sync() {
    console.log("Saving in Porous Layers");
    designStore.setCurrentPorousScenario(this.scenario)
  }
  beforeRouteLeave(to: Route, from: Route, next:Function){
    this.save();
    next()
  }

  get unitSystemIsImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial
  }

  /*
  Modulus calculation tooling
   */

  modulusCalculationMethod: "R-Value" | "CBR" | null = null;
  modulusCalculationMethodOptions = [
    {value: 'R-Value', text: 'R-Value'},
    {value: 'CBR', text: 'CBR'},
    {value: null, text: 'Manual'},
  ];

  get modulusCalculationHelptext(): string | null {
    switch (this.modulusCalculationMethod) {
      case'R-Value':
        return '<strong>R-Value Calculation:</strong> MR = 1,000 + (555)(R-value)';
      case 'CBR':
        return '<strong>CBR Calculation:</strong> MR = 2555 x CBR^0.64';
    }
    return 'Please determine the subgrade modulus and enter in the far right column.'
  }

  // AASHTO Soil model
  subgradeSoilType: string | null = null;
  subgradeAashtoModulusBounds = {
    'A-1-a': [38500, 42000],
    'A-1-b': [35500, 40000],
    'A-2-4': [28000, 37500],
    'A-2-5': [24000, 33000],
    'A-2-6': [21500, 31000],
    'A-2-7': [21500, 28000],
    'A-3': [24500, 35500],
    'A-4': [21500, 29000],
    'A-5': [17000, 25500],
    'A-6': [13500, 24000],
    'A-7-5': [8000, 17500],
    'A-7-6': [5000, 13500]
  };

  get subgradeSoilTypeOptions() {
    const soilTypes = Object.keys(this.subgradeAashtoModulusBounds).map((k): { value: string | null, text: string } => {
      return {value: k, text: k}
    });
    soilTypes.unshift({value: null, text: '---------'}); // Prepend default option
    return soilTypes
  }

  calcModulusFromRValue(){
    //@ts-ignore
    this.scenarioImperial.layer_2_modulus_psi = Number((1000 + 555 * this.scenarioImperial.rValue).toFixed(2));
    return true // Return true to play nice with getting called from "&& doStuff()" in v-in
  }

  calcModulusFromCbr(){
    //@ts-ignore
    this.scenarioImperial.layer_2_modulus_psi = Number((2555 * Math.pow(this.scenarioImperial.cbr, 0.64)).toFixed(2));
    return true // Return true to play nice with getting called from "&& doStuff()" in v-in
  }

  get thicknessUnit() {
    return this.unitSystemIsImperial ? 'in' : 'cm'
  }

  get modulusUnit() {
    return this.unitSystemIsImperial ? 'psi' : 'MPa'
  }
}


